import styled, { css } from 'styled-components';

// Styled Components
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';

export const ContainerTable = styled(Container)`
  display: flex;
  gap: 9.8rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 3.2rem;
  }
`;

export const BudgetCategoriesTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.8rem;
  width: 100%;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

export const ColorIndicator = styled.div<{ color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  border: 2px solid ${({ theme }) => theme.colors.greyLight};
  display: inline-block;
  margin-right: ${({ theme }) => theme.spaces.s}rem;
`;
